import { identify } from "./identify";
import * as track from "./track";

export default {
  track,
  identify,
};
